// Little badges for an element and a feeling: vector-free glyphs the system
// renders crisply. Shared by the battle HUD and the build menu (#207).

export const ELEMENT_GLYPH: Readonly<Record<string, string>> = {
  fire: '🔥',
  water: '💧',
  leaf: '🍃',
  frost: '❄️',
  spark: '⚡',
  stone: '🪨',
  shadow: '🌙',
  light: '✨',
};

export const FEELING_GLYPH: Readonly<Record<string, string>> = {
  joy: '😄',
  cozy: '☺️',
  brave: '😤',
  silly: '🤪',
  sleepy: '😴',
  spooky: '👻',
};
